import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a0dc2952ab6ae0014aaf5fd_1789049247690_98e6eb3d/reusa/src/app/corporate-training/page.tsx");
